import { createFileRoute, Link } from '@tanstack/react-router';
import {
  Avatar,
  Badge,
  Card,
  Group,
  SimpleGrid,
  Skeleton,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { IconBrandFacebook } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { trpc } from '../../lib/trpc';

function PagesIndex() {
  const list = trpc.analytics.pages.list.useQuery();

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
      <Stack gap="md">
        <Title order={2}>Page insights</Title>

        {list.isPending ? (
          <Skeleton height={240} />
        ) : (list.data ?? []).length === 0 ? (
          <Text c="dimmed">
            No connected Pages yet. Connect one from{' '}
            <Link to="/vendor/integrations/meta">Meta setup</Link>.
          </Text>
        ) : (
          <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
            {(list.data ?? []).map((p) => (
              <Card
                key={p.id}
                renderRoot={(props) => (
                  <Link to="/vendor/pages/$pageId" params={{ pageId: String(p.id) }} {...props} />
                )}
                style={{ textDecoration: 'none' }}
              >
                <Group wrap="nowrap">
                  <Avatar radius="xl" size="lg" src={p.profilePictureUrl ?? undefined}>
                    <IconBrandFacebook size={20} />
                  </Avatar>
                  <Stack gap={0} style={{ flex: 1, minWidth: 0 }}>
                    <Text fw={600} truncate>
                      {p.pageName}
                    </Text>
                    <Text c="dimmed" size="xs" ff="monospace" truncate>
                      {p.pageId}
                    </Text>
                    <Group gap={4} mt={4}>
                      <Badge variant="light" size="xs">
                        {p.followersCount.toLocaleString()} followers
                      </Badge>
                      <Badge
                        variant="light"
                        size="xs"
                        color={p.status === 'Connected' ? 'green' : 'red'}
                      >
                        {p.status}
                      </Badge>
                    </Group>
                    <Text size="xs" c="dimmed" mt={4}>
                      28d impressions: {p.impressions28d?.toLocaleString() ?? '—'} · engaged:{' '}
                      {p.engagement28d?.toLocaleString() ?? '—'}
                    </Text>
                  </Stack>
                </Group>
              </Card>
            ))}
          </SimpleGrid>
        )}
      </Stack>
    </motion.div>
  );
}

export const Route = createFileRoute('/vendor/pages')({ component: PagesIndex });
